import type { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

import { clsx } from 'clsx'

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const generateId = (length: number = 6): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  const charactersLength = characters.length

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export const formatCurrency = (amount: number, currency: string = 'đ'): string => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format phone number from local format (0xxx) to international format (+84xxx)
 * @param phone - Phone number in either 0xxx or +84xxx format
 * @returns Formatted phone number with +84 prefix if starting with 0
 */
export const formatPhoneNumber = (phone: string): string => {
  // If already starts with +84, return as is
  if (phone.startsWith('+84')) {
    return phone
  }
  // If starts with 0, replace with +84
  if (phone.startsWith('0') && phone.length >= 10) {
    return '+84' + phone.slice(1)
  }
  // Otherwise return as is
  return phone
}
